export default __webpack_public_path__ + "static/media/support-notes-logo-el-economista.ee772530.svg";